<template>
   <div>
       <div class="container-fluid">
           <div class="management-services-header">
               <div id="ms-header-bg"></div>
               <div class="header-text">
                   <p>
                       Tailor made Sourcing<br>
                        &nbsp; Procurement solutions<br> 
                        for our clients.<br>
                   </p>
               </div> 
           </div>
 
           <div class="mobile-img-header">
               <div>
                   <div style="background-image:url('../../public/images/management-services-header.jpg');background-size:cover;background-repeat:no-repeat;width:100%;height:0;padding-top:52vh;position:relative;"></div>
                   <div class="mobile-header-text">
                       <p>
                           Tailor made Sourcing<br>
                        &nbsp; Procurement solutions<br> 
                        for our clients.<br>
                       </p>
                   </div>
               </div>
           </div>
       </div>
 
       <div class="container-fluid cont">
           <div class="package-services-content">
               <div class="package-services-content-left" id="desktop-img-wrapper2">
                   <div id="services-imgs2">
                       <img src="../../public/images/package-services-img1.png" class="simg1">
                       <img src="../../public/images/Fittings-bl.jpg" class="simg2">
                       <img src="../../public/images/Flanges-br.jpg" class="simg2" style="margin-left:4%;">
                   </div>
               </div>
               <div class="package-services-content-right">
                   <h2 id="services-title" style="margin-bottom:30px;">The Synergy Way</h2>
                   <!-- <div class="package-services-content-right-subbox">
                       <p>
                           Representing products that are utilized in fabricated equipment we pass the full advantage of our mills capabilities on to our clients.
                       </p>
                   </div> -->
                   <div id="mobile-img-wrapper2"></div>
                   <p style="font-weight:bold;font-size:24px;margin-top:30px;">Package Offerings – The capability to provide multiple products</p>
                   <p id="services-text">
                          Synergy International Metals (SIM) client base covers a wide range of industrial and
manufacturing customers that require their own key products for their production. Over the
years Synergy has collected and analyzed its client’s requirements and from this has been
able to develop a suite of products, packaged separate or as multiples, that integrate
effectively. SIM takes full advantage of our manufacturer’s capability to best deliver products
that are utilized in fabricated equipment. Our sourcing &nbsp; procurement model is built on
direct relationships into the South Korean market and proven distribution channels across
our whole supply chain. SIM is able to supply a complete range of Fittings, Flanges, Custom
Forgings, Heads, Boltings, and Tube Sheets made from the best quality of seamless and
welded Carbon Steel, Stainless Steel, and Alloy Steel used in Oil and Gas, Petrochemical/
Chemical, Power Generation, LNG, and Manufacturing Plants &nbsp; Facilities.<br><br>
Synergy’s manufactures have technical literacy in both English and Korean making our
communication trustworthy. This factor promotes strong relationships within our diversified
group of manufacturers and supply chain and brings real value proving Synergy to be a value added partner.<br><br>
We strive to offer this packaging advantage so that our clients can compete in an everchanging market.<br>
                   </p>
                   <router-link to="/products">
                        <div class="btn-group-lg" style="margin-top:40px;display:inline-block;">
                            <button type="button" class="btn btn-primary" style="background: #305CA2; border-radius: 10px 0 0 10px; border: none; font-size: 17px; padding: 10px 21px;width: 244px;">View our Full Catalog</button>
                            <button type="button" class="btn btn-primary btn-default btn-sm" style="background: #5d7cad; border-radius: 0 10px 10px 0; border: none; font-size: 17px; padding: 10px 13px"><img src="../../public/images/right-arrow.svg" style="width: 18px;" ></button>
                        </div>
                    </router-link>
               </div>
           </div>

           <div class="management-services-content">
               <div class="management-services-content-left" id="desktop-img-wrapper">
                   <div id="services-imgs">
                       <img src="../../public/images/management-services-top-photo.jpg">
                       <img src="../../public/images/management-services-bottom-photo.jpg">
                   </div>
               </div>
               <div class="management-services-content-right">
                   <!-- <h2 id="services-title" style="margin-bottom:30px;">The Synergy Way</h2> -->
                   <!-- <div class="about-content-right-subbox">
                       <p>
                           Our ability to bridge the gap between the
                           East and West relative to socio/economic
                           conditions has been the formula for our
                           success.
                       </p>
                   </div> -->
                   <div id="mobile-img-wrapper"></div>
                   <p style="font-weight:bold;font-size:24px">Management Services – Keys to delivering success</p>
                   <p id="services-text">
Synergy International Metals (SIM) ability to combine the best of East and West in a global
economy has been our formula for success. We have combined Supply, Procurement,
Inspections, and Logistics into a Full Supply &nbsp; Procurement Cycle that delivers results by:<br>
                    <ul style="margin:12px 0 0 5%;">
                        <li>Direct access to the South Korean supply market is our key to assuring supply and maintaining product quality.</li>
                        <li>Synergy has integrated global freight forwarders. We have studied and developed freight routes that are efficient and affective.</li>
                        <li>We have fully integrated our logistics partners throughout the whole order and delivery process.</li>
                        <li>Our business partners have been part of our sourcing &nbsp; procurement model since the inception of the company and understand our business and our client base.</li>
                        <li>Possess, and are constantly developing, local supply chains.</li>
                        <li>Our model assures compliance to (DDP Terms) Deliver Duty Paid making it fully door to door for its clients.</li>
                        <li>Communication with our partners and clients is open and transparent.</li>
                    </ul><br>
                    We strive to achieve the highest level of performance so that our clients can compete in an ever-changing market.
                   </p>
                   <router-link to="/profile">
                        <div class="btn-group-lg" style="margin-top:40px;display:inline-block;">
                            <button type="button" class="btn btn-primary" style="background: #305CA2; border-radius: 10px 0 0 10px; border: none; font-size: 17px; padding: 10px 21px;width: 244px;">View our Profile</button>
                            <button type="button" class="btn btn-primary btn-default btn-sm" style="background: #5d7cad; border-radius: 0 10px 10px 0; border: none; font-size: 17px; padding: 10px 13px"><img src="../../public/images/right-arrow.svg" style="width: 18px;" ></button>
                        </div>
                    </router-link>
               </div>
           </div>
       </div>
   </div>
</template>
 
<script>
import $ from 'jquery';
 
export default {
   name: "Services",
   head: {
      script: [
        { type: 'text/javascript', src: 'https://www.googletagmanager.com/gtag/js?id=G-04SEEX5EX2', async: true, body: false}, // Insert in bod
      ],
    },
   mounted() {
       $(function(){
           MoveSearch(x);
       });
       var x = window.matchMedia("(max-width: 900px)")
       x.addListener(MoveSearch)
       function MoveSearch(x) {
           if (x.matches) {
               $('#services-imgs').appendTo('#mobile-img-wrapper');

               $('#services-imgs2').prependTo('#mobile-img-wrapper2');
               $('#services-imgs2').append('<div class="clearfix"></div>');
           } else {
               $('#services-imgs').appendTo('#desktop-img-wrapper');

               $('#services-imgs2').appendTo('#desktop-img-wrapper2');
           }
       }
   }
}
 
 
$(function(){
   MoveSearch(x);
});
 
var x = window.matchMedia("(max-width: 900px)")
x.addListener(MoveSearch)
 
function MoveSearch(x) {
 if (x.matches) {
   $('#services-imgs').appendTo('#mobile-img-wrapper');
   $('#services-imgs2').prependTo('#mobile-img-wrapper2');
   $('#services-imgs2').append('<div class="clearfix"></div>');
 } else {
   $('#services-imgs').appendTo('#desktop-img-wrapper');
   $('#services-imgs2').appendTo('#desktop-img-wrapper2');
 }
}
 
window.dataLayer = window.dataLayer || [];
  function gtag(){window.dataLayer.push(arguments);}
  gtag('js', new Date());

  gtag('config', 'G-04SEEX5EX2');
</script>
 
<style scoped>
   * {
       box-sizing: border-box;
       margin: 0;
       padding: 0;
       font-family: 'Forma DJR Micro', sans-serif;
   }
   .cont {
       padding: 0 7% 0 7%;
   }
   .management-services-header {
       background: url("../../public/images/management-services-header.jpg");
       background-size: cover;
       background-repeat: no-repeat;
       width: 100%;
       position: relative;
       background-position: center;
   }
   #ms-header-bg {
       background-image:url('../../public/images/management-services-header.jpg');
       background-size: cover;
       background-repeat:no-repeat;
       width:100%;
       height:0;
       padding-top:35%;
       position:relative;
       visibility: hidden;
       background-position: center;
   }
   #header-gDash {
       width:49%;
       max-width:1080px;
       height:3px;
       background:#00C5BC;
       position:absolute;
       bottom:17%;
   }
   .header-text, .mobile-header-text {
       position: absolute;
       top: 0;
       padding: 110px 4% 0 0;
       width: 100%;
   }
   .header-text p {
       color: white;
       font-size: clamp(35px, 3.3vw, 65px);
       line-height: 1.3em;
       font-weight: bold;
       text-align: right;
       text-shadow: 6px 10px 22px black;
   }
   .mobile-header-text p {
       color: white;
       font-size: clamp(20px, 12vw, 50px);
       line-height: 1.3em;
       font-weight: bold;
       text-align: right;
       text-shadow: 6px 10px 22px black;
   }
   .mobile-img-header {
       background: url("../../public/images/management-services-header.jpg") bottom;
       background-size: cover;
       background-repeat: no-repeat;
       width: 100%;
       position: relative;
       display: none;
   }
   #services-title {
       font-size: 40px;
       line-height: 60px;
       font-weight: bold;
   }
   .package-services-content {
       margin-top: 6%;
   }
   .package-services-content-left, .package-services-content-right {
       width: 50%
   }
   .package-services-content-left img {
       height: auto;
       display: block;
   }
   .package-services-content {
       margin-top: 6%;
       display: flex;
       flex-direction: row;
       justify-content: space-between;
   }
   .management-services-content-left, .management-services-content-right {
       width: 50%
   }
   .management-services-content-left img {
       width: 85%;
       height: auto;
       display: block;
       margin-bottom: 50px ;
   }
   .management-services-content {
       margin-top: 10%;
       display: flex;
       flex-direction: row;
       justify-content: space-between;
   }
   .about-content-right-subbox {
       background: #004884;
       width: 100%;
       padding: 5%;
       color: white;
       font-size: 24px;
       font-weight: thin;
       margin: 6% 0 8% 0;
   }
   #mobile-management-header {
       margin: 50px 0 0 0;
       font-size: 30px;
       line-height: 50px;
       margin-bottom: 30px;
       font-weight: bold;
   }
   #mobile-subbox {
       background: #004884;
       width: 100%;
       padding: 9%;
       color: white;
       font-size: clamp(20px, 1.5vw, 40px);
       font-weight: thin;
       margin: 15px 0 50px 0;
   }
   #mobile-management-content {
       display: none;
   }
   .nxt-btn-box {
       background: #00C5BC;
       border-radius: 0;
       border: none;
       font-size: 17px;
       padding: 10px 21px;
   }
   .nxt-btn-arrow {
       background: #79D9D5;
       border-radius: 0;
       border: none;
       font-size: 17px;
       padding: 10px 13px;
   }
   #services-text {
       font-size: 17px;
       margin-top: 35px;
       line-height: 32px;
       text-align: justify;
   }
   .simg1 {
       width: 82%;
       margin: 0 0 4% 0;
   }
   .simg2 {
       width: 39%;
       float: left;
   }
   @media screen and (max-width: 1200px) {
       #header-gDash {
           width:44%;
       }
   }
   @media screen and (max-width: 1100px) {
       #header-gDash {
           width:40%;
       }
   }
   @media screen and (max-width: 1000px) {
       #header-gDash {
           width:35%;
       }
   }
   @media screen and (max-width: 900px) {
       .cont {
           padding: 0 50px 60px 50px;
       }
       .management-services-header {
           display: none;
       }
       .mobile-img-header {
           display: block;
       }
       #mobile-management-bot {
           margin-bottom: 50px;
       }
       .header-text, .mobile-header-text {
      padding: 100px 4% 0 0;
    }
    .package-services-content {
           flex-direction: column;
       }
       .package-services-content-right-subbox {
           width: 100vw;
           position: relative;
           left: calc(-50vw + 50%);
           padding: 9%;
           color: white;
           font-size: clamp(20px, 1.5vw, 24px);
           font-weight: thin;
           margin: 15px 0 50px 0;
       }
       #mobile-img-wrapper, .package-services-content-right {
           width: 100%;
       }
       .simg1 {
           width: 100%;
       }
       .simg2 {
           width: 48%;
       }
   .mobile-header-text p {
     font-size: clamp(20px,7vw,40px);
   }
       .management-services-content {
           flex-direction: column;
           display: block;
       }
       #mobile-img-wrapper, .management-services-content-right {
           width: 100%;
       }
       #mobile-img-wrapper img {
           width: 100%;
           max-width: 550px;
           height: auto;
           display: block;
           margin: 0 auto 40px auto;
       }
       .about-content-right-subbox {
           width: 100vw;
           position: relative;
           left: calc(-50vw + 50%);
           padding: 9%;
           color: white;
           font-size: clamp(20px, 1.5vw, 24px);
           font-weight: thin;
           margin: 15px 0 50px 0;
       }
       #services-title {
           font-size: 35px;
       }
   }
   @media screen and (max-width: 500px) {
       .cont {
           padding: 0 20px 50px 20px;
       }
       .mobile-img-header {
           max-height:335px;
       }
       #mobile-management-header {
           font-size: 27px;
           line-height: unset;
       }
       .mobile-header-text p {
           font-size: clamp(25px,6.4vw,35px);
       }
       .nxt-btn-box, .nxt-btn-arrow {
           font-size: 14px;
       }
       #mobile-subbox {
           font-size: 20px;
       }
       #services-text {
           font-size: 16px;
           line-height: 30px;
       }
       #services-title {
           font-size: 26px;
           line-height: 42px;
       }
       .about-content-right-subbox {
           font-size: 20px;
       }
   }
   @media screen and (max-width: 335px) {
       .mobile-header-text p {
           font-size: 24px;
           line-height: 1.25em;
       }
   }
   /* @media screen and (max-width: 290px) {
       .mobile-img-header {
           margin-top:-30%;
       }
   } */
</style>
 

